import { ReactNode } from 'react';

import { MonitorSmartphoneIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { ResponseMessage } from '@/shared/types/tryIt';
import { switchChannelName } from '@/util/switchChannel';

import { responseClasses } from './constants';

type SwitchChannelMessage = Extract<ResponseMessage, { type: 'switch_channel' }>;

interface SwitchChannelResponseProps {
  response: SwitchChannelMessage;
  icon: ReactNode;
  goToButton: ReactNode;
}

// Try it has no desk, so no link is minted: the card shows what a visitor on another channel gets.
export const SwitchChannelResponse = ({
  response,
  icon,
  goToButton,
}: SwitchChannelResponseProps) => {
  const { t } = useTranslation();
  const channel = switchChannelName(t, response.channel);

  return (
    <div className={responseClasses}>
      {icon}
      <div className="flex max-w-sm flex-col gap-3 overflow-hidden rounded-xl bg-background p-4 shadow-sm">
        <p className="flex items-center gap-2 text-sm leading-5 font-semibold text-foreground">
          <MonitorSmartphoneIcon size={16} />
          {t('actions.types.switch_channel')}
        </p>
        <p className="text-sm leading-5 text-muted-foreground">
          {t('try_it.switch_channel_notice', { 0: channel })}
        </p>
        <Button variant="outline-neutral" size="sm" disabled className="w-full">
          {t('try_it.switch_channel_button', { 0: channel })}
        </Button>
      </div>
      {goToButton}
    </div>
  );
};
